/**
 * TODO: refactor to use StyledComponents from rental-manager-env
 *
 * that StyledEmptySimpleCard component does not wrap SimpleCard it wraps Card
 * we can move styles from StyledEmptySimpleCard and port to StyledEmptyStateContainer
 * we can update StyledEmptySimpleCard to have 0 padding and 0 margin
 */

/**
 * Used to handle empty states of the comet verticals: applications, leases, payments, etc.
 */
import styled, { css } from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

import SimpleCard from '../components/SimpleCard';

const getResponsiveMaxWidth = () => {
  return css`
    margin: 0 auto;
    max-width: 608px;
  `;
};

export const StyledEmptySimpleCard = styled(SimpleCard)`
  padding-top: ${spaceMixin(5)};
  padding-bottom: ${spaceMixin(5)};
  padding-left: ${spaceMixin('md')};
  padding-right: ${spaceMixin('md')};
`;

export const StyledEmptyStateContainer = styled.div`
  text-align: center;
  ${getResponsiveMaxWidth}
`;

export const StyledEmptyIconContainer = styled.div`
  margin-bottom: ${spaceMixin('xs')};
`;
